import Dialog from "../components/Dialog";
import { useState } from "react";
import ReportForm from "./form/ReportForm";

export default function PasswordDialog({
  visible,
  hide,
  item,
  component,
  ...props
}) {
  const [loading, setLoading] = useState(false);

  return (
    <Dialog
      title={"Enter Password"}
      visible={visible}
      onCancel={hide}
      closable={!loading}
    >
      <ReportForm
        {...props}
        id={item?.id}
        submitting={loading}
        setSubmitting={(l) => setLoading(l)}
        onCancel={hide}
        component={component}
      />
    </Dialog>
  );
}
